export default {"src":"/_next/static/media/0xfa9343c3897324496a05fc75abed6bac29f8a40f.ef6ecb81.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};